const Vue = require('vue')
const moment = require('moment')
const { url, plural, asset, formatMoney } = require('sci/utils')
const { humanizeMoney, humanizeNumber } = require('microsistec/humanize')

const now = moment.utc()
const nowLocal = moment.utc().local()

Vue.filter('trace', function (value) {
    console.trace(value)
    return `<pre>${JSON.stringify(value, null, '\t')}</pre>`
})

Vue.filter('url', function (path) {
    return url(path)
})

Vue.filter('asset', function (path) {
    return asset(path)
})

Vue.filter('humanizedMoney', function (_value) {
    return humanizeMoney(_value)
})

Vue.filter('humanizedNumber', function (_value) {
    return humanizeNumber(_value)
})

Vue.filter('money', function (_value) {
    return formatMoney(_value)
    // return 'R$ ' + Inputmask.format(value, {'alias': 'money'});
})

Vue.filter('firstName', function (value) {
    if (!value) return
    return value.split(' ').shift()
})

Vue.filter('date_format', function (value, format) {
    if (value) {
        return moment.utc(value).local().format(format)
    } else {
        return ''
    }
})

Vue.filter('timeagosimpler', function(value) {
    const now = moment();
    const secondsAgo = now.diff(moment.utc(value), 's');

    const aMinute = 60
    const aHour = aMinute * 60;
    const aDay = aHour * 24;
    const aMonth = aDay * 30;
    const aYear = aMonth * 12;

    if (secondsAgo > aYear) {
        return `${Math.floor(secondsAgo/aYear)}a`
    }

    if (secondsAgo> aMonth) {
        return `${Math.floor(secondsAgo/aMonth)}M`
    }
    if (secondsAgo> aDay) {
        return `${Math.floor(secondsAgo/aDay)}d`
    }
    if (secondsAgo> aHour) {
        return `${Math.floor(secondsAgo/aHour)}h`
    }
    if (secondsAgo> aMinute) {
        return `${Math.floor(secondsAgo/aMinute)}m`
    }
    return `${secondsAgo}s`
})

Vue.filter('date', function (value) {
    if (value) {
        if (/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/.test(value)) {
            return moment.utc(value).format('L')
        }

        return moment.utc(value).local().format('L')
    } else {
        return ''
    }
})

Vue.filter('datetime', function (value) {
    if (value) {
        const date = moment.utc(value).local();

        if (date.year() === nowLocal.year()) {
            return date.format('DD \\d\\e MMMM HH:mm')
        } else {
            return date.format('DD \\d\\e MMMM \\d\\e YYYY HH:mm')
        }
    } else {
        return ''
    }
})



Vue.filter('time', function (value) {
    if (value) {
        const date = moment.utc(value).local();

        if (date.year() === nowLocal.year() && date.month() === nowLocal.month() && date.day() === nowLocal.day()) {
            return date.format('HH:mm:ss')
        } else {
            return date.format('DD \\d\\e MMMM \\d\\e YYYY HH:mm:ss')
        }
    } else {
        return ''
    }
})

Vue.filter('datetime_with_year', datetimeWithYear)
export function datetimeWithYear(value) {
    if (value) {
        return moment.utc(value).local().format('DD / MM / YYYY HH:mm')
    } else {
        return ''
    }
}
Vue.filter('unixdatetime', function (value) {
    if (value) {
        const date = moment.unix(value).local();

        if (date.year() === nowLocal.year()) {
            return date.format('DD \\d\\e MMMM HH:mm')
        } else {
            return date.format('DD \\d\\e MMMM \\d\\e YYYY HH:mm')
        }
    } else {
        return ''
    }
})

Vue.filter('daysago', function (value) {
    if (value) {
        return now.diff(moment.utc(value).local(), 'days') + 'd'
    } else {
        return ''
    }
})

Vue.filter('timeago', function (value) {
    if (value) {
        return now.to(moment.utc(value).local())
    } else {
        return ''
    }
})

Vue.filter('timeagoshort', function (value) {
    if (value) {
        const text = now.to(moment.utc(value).local())
        const textReplaced = text.replace(' meses', 'm')
            .replace(' dias', 'd')
            .replace(' anos', 'a')
            .replace(' mes', 'm')
            .replace(' dia', 'd')
            .replace(' ano', 'a')
        return textReplaced
            .replace('umd', '1d')
            .replace('uma', '1a')
            .replace('umm', '1m')
    } else {
        return ''
    }
})

Vue.filter('phone', formatPhone)
export function formatPhone(value) {
    if (!value) {
        return ''
    }

    value = value.replace(/[^0-9\*]/, '')

    if (value.indexOf('*') < 0) {
        if (value.length <= 9) {
            return value.replace(/^(.{4,5})(.{4})/, '$1-$2')
        } else {
            return value.replace(/^(.{2})(.{4,5})(.{4})/, '$1 $2-$3')
        }
    }

    return value
}

Vue.filter('yes_no', function (value) {
    return value ? 'Sim' : 'Não'
})

Vue.filter('event_range_line', function (event) {
    const date = moment.utc(event.start).local()

    if (date.year() === nowLocal.year()) {
        return date.format('DD \\d\\e MMMM HH:mm')
    } else {
        return date.format('DD \\d\\e MMMM \\d\\e YYYY HH:mm')
    }
})

Vue.filter('plural', function (value, singular, _plural, none = null) {
    return plural(value, singular, _plural, none)
})

Vue.filter('wwwify', function (value) {
    if (value && value.indexOf('www.') !== 0) {
        return `www.${value}`
    }

    return value
})

const fileSize = function (bytes) {
    const thresh = 1024

    if (Math.abs(bytes) < thresh) {
        return bytes + ' B'
    }

    const units = ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

    let u = -1

    do {
        bytes /= thresh
        ++u
    } while (Math.abs(bytes) >= thresh && u < units.length - 1)

    return bytes.toFixed(1) + ' ' + units[u]
}

Vue.filter('fileSize', fileSize)

Vue.filter('downloadSpeed', function (bytes) {
    if (bytes !== null) {
        return fileSize(bytes) + '/s'
    }

    return null
})

Vue.filter('short-name', function (name) {
    return name.split(' ').slice(0, 2).join(' ')
})



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/filters.js